export enum PlanStatusEnum {
    ACTIVE = "Ativo",
    CANCELLATION_PENDING = "Cancelamento Pendente",
    OVERDUE = "Atrasado",
    CANCELED = "Cancelado",
    FULLY_CANCELED = "Totalmente Cancelado",
    ACTIVATION_PENDING = "Ativação Pendente",
    FINALIZED = "Finalizado",
    UNKNOWN = "Desconhecido",
}